/**
 * List of official brand partners.
 *
 * Structure:
 * [
 *  {
 *    name: "Let's Do This"
 *    url: "https://letsdothis.com"
 *    logo: ""
 *    region: ""
 *  },
 *  ...
 * ]
 */
export default [
  {
    name: 'Cycling Maratona',
    url: 'http://cyclingmaratona.co.uk/',
    logo: 'cycling_maratona.png',
    region: 'UK',
  },
  {
    name: 'Weybridge 10k',
    url: 'https://www.weybridge10k.com/',
    logo: 'Weybridge.png',
    region: 'UK',
  },
  {
    name: 'AAT Events',
    url: 'https://www.aat-events.com/',
    logo: 'AAT.png',
    region: 'UK',
  },
  {
    name: 'Eventbaxx',
    url: 'https://www.eventbaxx.com/en',
    logo: 'Eventbaxx.png',
    region: 'UK',
  },
  {
    name: 'eventrac',
    url: 'https://www.eventrac.co.uk/',
    logo: 'eventrac.png',
    region: 'UK',
  },
  {
    name: 'Forbes Triathlon Club',
    url: 'https://www.forbesrunningandtriclub.com/',
    logo: 'ForbesTriathlonClub.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Hell of the West',
    url: 'http://www.hellofthewest.com/',
    logo: 'HellOfTheWest.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Hal Sports',
    url: 'https://www.halsports.net/',
    logo: 'HalSports.png',
    region: 'USA',
  },
  {
    name: 'Glow in the Park',
    url: 'http://www.votwo.co.uk/products/glow-in-the-park',
    logo: 'GlowInThePark.png',
    region: 'UK',
  },
  {
    name: 'Limelight Sports',
    url: 'https://www.limelightsports.com/',
    logo: 'LimelightSports.png',
    region: 'UK',
  },
  {
    name: 'Love Trails Festival',
    url: 'https://www.lovetrailsfestival.co.uk/',
    logo: 'LoveTrailsFestival.png',
    region: 'UK',
  },
  {
    name: 'Mascot Sports',
    url: 'http://www.mascotsports.com/',
    logo: 'MascotSports.png',
    region: 'USA',
  },
  {
    name: 'Perfect Motion Events',
    url: 'http://www.perfectmotion.org/',
    logo: 'PerfectMotionEvents.png',
    region: 'UK',
  },
  {
    name: 'RiderHQ',
    url: 'https://www.riderhq.com/',
    logo: 'RiderHQ.png',
    region: 'UK',
  },
  {
    name: 'Race Slo',
    url: 'https://www.raceslo.com/',
    logo: 'RaceSlo.png',
    region: 'USA',
  },
  {
    name: 'True Grit Events',
    url: 'https://www.truegritevents.com/',
    logo: 'TrueGritEvents.jpg',
    region: 'Aus/NZ',
  },
  {
    name: 'Worldwide Cancer Research',
    url: 'https://www.worldwidecancerresearch.org/',
    logo: 'WorldwideCancerResearch.png',
    region: 'UK',
  },
  {
    name: 'XcelSports',
    url: 'https://www.xcelsports.com.au/',
    logo: 'XcelSportsEvents.png',
    region: 'Aus/NZ',
  },
  {
    name: 'MS Events',
    url: 'https://www.ms.org.au/events/a-concert.aspx',
    logo: 'MSEvents.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Beach 2 Brother',
    url: 'https://www.beachtobrother.com.au/',
    logo: 'Beach2Brother.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Four Vines Running Festival',
    url: 'https://www.fourvinesrunningfestival.com.au/',
    logo: 'FourVinesRunningFestival.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Tour de Trails',
    url: 'http://www.tourdetrails.com/',
    logo: 'TourDeTrails.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Sport3',
    url: 'http://www.lcwjervisbay.com/',
    logo: 'Sport3.png',
    region: 'Aus/NZ',
  },
  {
    name: 'SME360',
    url: 'http://www.sme360.com.au/',
    logo: 'SME360.png',
    region: 'Aus/NZ',
  },
  {
    name: '3 Bay Challenge',
    url: 'https://www.3baychallenge.com.au/',
    logo: '3BayChallenge.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Richmond Running Festival ',
    url: 'https://www.richmondrunfest.com/',
    logo: 'RichmondRunningFestival.png',
    region: 'UK',
  },
  {
    name: 'MMI Events',
    url: 'http://mmievents.com.au/',
    logo: 'MmiEvents.png',
    region: 'Aus/NZ',
  },
  {
    name: 'Walking With The Wounded ',
    url: 'https://walkingwiththewounded.org.uk/',
    logo: 'WalkingWithTheWounded.png',
    region: 'UK',
  },
  {
    name: 'Maverick Races',
    url: 'http://www.maverick-race.com/races/',
    logo: 'Maverick.png',
    region: 'UK',
  },
  {
    name: 'Tri-Adventure',
    url: 'https://www.triadventure.co.uk/',
    logo: 'TriAdventure.png',
    region: 'UK',
  },
  {
    name: 'Total Motion Events',
    url: 'https://totalmotionevents.co.uk/',
    logo: 'TotalMotion.png',
    region: 'UK',
  },
  {
    name: 'Extreme Amphibirun',
    url: 'https://amphibirun.co.uk/',
    logo: 'ExtremeAmphibirun.png',
    region: 'UK',
  },
  {
    name: 'The 305 Half Marrathon & 5K',
    url: 'https://www.305halfmarathon.com/',
    logo: '305HalfMarathon.png',
    region: 'USA',
  },
  {
    name: 'Blue Cheetah Sports Timing, LLC',
    url: 'http://www.bluecheetahtiming.com/',
    logo: 'BlueCheetah.png',
    region: 'USA',
  },
  {
    name: 'The Miami Marathon',
    url: 'https://www.themiamimarathon.com/',
    logo: 'TheMiamiMarathon.png',
    region: 'USA',
  },
  {
    name: 'Sri Chinmoy Marathon Team',
    url: 'https://uk.srichinmoyraces.org/races/london',
    logo: 'SriChinmoy.jpg',
    region: 'UK',
  },
];
